interface Config {
  jointApiUrl: string
  pageUrls: {
    ACCOUNT_PAGE: string | null
    ORDER_HISTORY_PAGE: string | null
  }
}

const config: Config = {
  jointApiUrl: 'https://api.jointechnology.io/',
  pageUrls: {
    ACCOUNT_PAGE: window.joint_customers?.account_page,
    ORDER_HISTORY_PAGE: window.joint_customers?.order_history_page,
  }
}

export default config;
